import useDocumentTitle from 'hooks/useDocumentTitle';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CustomPagination, NavTabs } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { getLRListData } from '_services/accountsServices/lrServices'
import LoadingBar from 'react-top-loading-bar';
import { useParams } from 'react-router-dom';
import BootstrapTable from 'components/BootstrapTable';
import { UserContext } from 'context';
import { getInvoiceBillRaiseListData } from '_services/invoiceBillRaiseServices';
import { utils } from 'helper';
import { Link } from 'react-router-dom';
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';

const Invoice = () => {

    useDocumentTitle("Invoice | T360");
    let { id } = useParams();
    const { masterData } = useContext(UserContext)
    const loadingBarRef = useRef(null);
    const [invoiceList, setInvoiceList] = useState([])
    const [loading, setLoading] = useState(false);

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        status: 1,
    });
    const getDataInvoiceBillRaiseList = async () => {
        setLoading(true);
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                consignor_id: id ? id : '',
                company_id: StorageService.getCompanyId(),
            }
            const res = await getInvoiceBillRaiseListData(object);
            if (res?.responseCode == 200) {
                setLoading(false);
                setInvoiceList(res?.data?.billraise_list);
                setTotalItems(res?.data?.total_record);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        getDataInvoiceBillRaiseList();
    }, [filter, id])

    const columns = [
        { header: "Invoice Number", accessor: "invoice_number" },
        { header: "Invoice Date", accessor: "date" },
        { header: "Party", accessor: "consignor_id" },
        { header: "Branch Name", accessor: "branch" },
        { header: "Invoice Amount", accessor: "invoice_amount" },
        { header: "Balance", accessor: "balance" },
        { header: "Due Date", accessor: "due_date" },
        { header: "Actions", accessor: "action" },
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            invoice_number:
                <Link to={`/invoicing/details/${item?._id}`} style={{ textDecoration: 'none', display: 'inline-block' }}>
                    <CustomTooltip txtClass='__tooltipTxt_bx'>
                        <p>{item?.invoice_number ? item?.invoice_number : '-'}</p>
                    </CustomTooltip>
                </Link>,
            date: <>{item?.invoice_date ? utils.formateDateCalander(item?.invoice_date) : '-'}</>,
            consignor_id: <>{item?.consignor_id?.name ? item?.consignor_id?.name : '-'}</>,
            branch: <>{item?.branch_id?.branch ? item?.branch_id?.branch : '-'}</>,
            invoice_amount: <>
                <Link to={`/invoicing/details/${item?._id}`} style={{ textDecoration: 'none', display: 'inline-block' }}>
                    &#x20B9; {item?.invoice_summary?.invoice_amount ? item?.invoice_summary?.invoice_amount?.toFixed(2) : 0.0}
                </Link>
            </>,
            balance:
                <>
                    <Link to={`/invoicing/details/${item?._id}`} style={{ textDecoration: 'none', display: 'inline-block' }}>
                        &#x20B9; {item?.invoice_summary?.balance ? (item?.invoice_summary?.balance)?.toFixed(2) : 0.0}
                    </Link>
                </>,
            due_date: <>{item?.due_date ? utils.formateDateCalander(item?.due_date) : '-'}</>,
            action: <>{item?.invoice_status ? masterData.invoice_status[item?.invoice_status] : '-'}</>,
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <div className='_tabWith_topTab'>
                <BootstrapTable
                    columns={columns}
                    data={rowListData(invoiceList?.length > 0 ? invoiceList : [])}
                    isLoading={loading}
                />
                {invoiceList?.length > 0 &&
                    <div className='paginationFt_avt '>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>}
            </div>

        </div>
    )
}

export default Invoice